export const convertToSlug = ( text:string ) => text.toLowerCase()
  .replace( / /g, '-' )
  .replace( /[^\w-]+/g, '' );

export const convertToSimpleSlug = ( text:string ) => text.toUpperCase();

export const parseNdaMetadata = ( data?: string ): { key: string; value: any }[] => {
  try {
    if ( !data ) return [];

    const parsed = JSON.parse( data );

    if ( typeof parsed !== 'object' || parsed === null || Array.isArray( parsed ) ) {
      return [];
    }

    return Object.entries( parsed ).map( ( [key, value] ) => ( { key, value } ) );
  } catch ( err ) {
    console.error( 'Error parsing ndaMetadata:', err );
    return [];
  }
};

export const getNdaStatusName = ( status: String, ndaEnvelopeId?: boolean ) => {
  if ( status === 'COMPLETADO' && ndaEnvelopeId ) {
    return 'FIRMADO';
  }
  if ( status === 'COMPLETADO' && !ndaEnvelopeId ) {
    return 'FORZADO POR ADMIN';
  }
  if ( status === 'PROCESANDO' ) {
    return 'INICIADO';
  }
  if ( status === 'BLOQUEADA' ) {
    return 'BLOQUEADA';
  }

  return 'NO INICIADO';
};

export const getInvitationStatusName = ( status: String ) => {
  if ( status === 'BLOQUEADA' ) {
    return 'BLOQUEADA';
  }

  return 'ACTIVA';
};

export const generarHash = async ( texto: string ): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode( texto );
  const hashBuffer = await crypto.subtle.digest( 'SHA-256', data );
  const hashArray = Array.from( new Uint8Array( hashBuffer ) );
  const hashHex = hashArray.map( ( b ) => b.toString( 16 ).padStart( 2, '0' ) ).join( '' );
  return hashHex;
};

export const copyClipboard = ( url: string, setExtra?: ()=>void ) => {
  navigator.clipboard.writeText( url )
    .then( () => {
      if ( setExtra ) {
        setExtra();
      }

      console.log( 'URL successfully copied to clipboard' );
    } )
    .catch( ( err ) => {
      console.error( 'Failed to copy URL: ', err );
    } );
};
